import React from 'react';

import MessagePage from '@dashboard/components/pages/MessagePage';
import { Button } from '@mui/material';

export default function VerificationFailure() {
  return (
    <MessagePage
      icon="ERROR"
      title="Email verification failed"
      description="There was a problem verifying your email address. Please contact Waypoint support for details."
      action={
        <Button href="http://www.usewaypoint.com/help" target="_blank" variant="contained" type="submit">
          Contact support
        </Button>
      }
    />
  );
}
